import { GenerateDevicePayload } from '@src/types/Device';

const generateDevices: GenerateDevicePayload = {
  siteControllerId: '000000F',
  unitControllers: {
    engineeringIds: [
      '0000001F',
      '0000002F',
      '0000003F',
      '0000004F',
      '0000005F',
      '0000006F',
      '0000007F',
      '0000008F',
      '0000009F',
      '000000AF',
      '000000BF',
      '0000012F',
    ],
    namePrefix: 'Unit ',
    nameSuffix: '',
  },
  sourceDevices: [
    {
      type: 'tsc',
      parentType: 'siteController',
      count: 4,
    },
    {
      type: 'powinems',
      parentType: 'siteController',
      count: 4,
    },
    {
      type: 'powinbess',
      parentType: 'powinems',
      count: 4,
    },
    {
      type: 'powinrack',
      parentType: 'powinbess',
      count: 4,
    },
    {
      type: 'mp',
      parentType: 'tsc',
      count: 4,
      namePrefix: 'Megapack',
    },
    {
      type: 'bms',
      parentType: 'unitController',
      count: 4,
    },
    {
      type: 'rack',
      parentType: 'bms',
      count: 2,
    },
    {
      type: 'meter',
      parentType: 'siteController',
      count: 2,
    },
    {
      type: 'pcs',
      parentType: 'unitController',
      count: 2,
    },
  ],
};

export default generateDevices;
